import type { Catalog, DocumentNavigationAssignment, NavigationAssignment, SourceDocument } from "./types";

export const RELEASE_ID = "life-map-2026-10-04-18de323d-r6";
const base = `./releases/${RELEASE_ID}`;
let catalogPromise: Promise<Catalog> | undefined;
let navigationPromise: Promise<{ assignments: NavigationAssignment[]; documentAssignments: DocumentNavigationAssignment[] }> | undefined;

async function checked<T>(url: string): Promise<T> {
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok) throw new Error(`内容加载失败（${response.status}）：${url}`);
  return response.json() as Promise<T>;
}
export const getCatalog = () => catalogPromise ??= checked<Catalog>(`${base}/catalog.json`);
export const getNavigation = () => navigationPromise ??= checked<{ assignments: NavigationAssignment[]; documentAssignments: DocumentNavigationAssignment[] }>(`${base}/navigation.json`);
export const getDocument = (id: string) => checked<SourceDocument>(`${base}/documents/${encodeURIComponent(id)}.json`);
export const releaseUrl = (suffix: string) => `${base}/${suffix}`;

export function itemMarkdown(markdown: string, start: number, endInclusive: number) {
  return markdown.split(/(?<=\n)/).slice(start - 1, endInclusive).join("");
}
